import HttpCondominio from '@/typescript/servicos/http/condominio'
import HttpFastAPI from '@/typescript/servicos/http/fastapi'
import { AxiosRequestConfig } from 'axios'
import {
  IRequestFolhaParcialLoteDeLinhasPorLocalDeTrabalho,
  IRequestFolhaParcialLoteDeLinhasEmpregado,
  IRequestFolhaParcialLoteDeLinhasGrupo,
  IRequestFolhaParcialSubRotaBase,
  IRequestLoteDeJustificativasDasLinhas,
  IRequestDiasDaFolhaPorEntidade,
  IRequestProcessarPontos,
  IRequestRegerarJornadasQuePrecisam,
  IRequestGerarJornadasQueFaltam,
  IRequestVerificarDia,
  IRequestAcumuladoBH,
  IRequestResumoBancoDeHorasPorEmpregado
} from '@/typescript/modulos/estrutura-de-pontos-da-empresa/Folha/repositorio/folha.respositorio.request'
import {
  IResponseFolhaParcialSubRotaLinhasSucesso,
  IResponseFolhaParcialSubRotaSucesso,
  IResponseFolhaParcialSucessoBase,
  IResponsePadraoFastAPI,
  IResponseAcumuladoBH,
  IResponseResumoBancoDeHorasPorEmpregado
} from '@/typescript/modulos/estrutura-de-pontos-da-empresa/Folha/repositorio/folha.respositorio.response'
import { HttpResponse } from '@/typescript/servicos/http/http.interfaces'
import { DiaDaFolhaResponse } from '../dominio/linha.interface'

export enum RotaFolhaParcial {
  TimesheetPartial = 'timesheet-partial'
}

export type Resposta<T> = Promise<HttpResponse<IResponseFolhaParcialSucessoBase<T>>>
export type RespostaFolhaV2<T> = Promise<HttpResponse<T>>

export enum SubRotaFolhaParcial {
  Lines = 'lines',
  Pts = 'pts',
  Djs = 'djs',
  Justifies = 'justifies',
  Whbs = 'whbs',
  Approvals = 'approvals'
}

export type HelperFolhaResposta = {
  ResponseFolhaParcialSubRotaLinhasSucesso: Resposta<IResponseFolhaParcialSubRotaLinhasSucesso>;
  ResponseFolhaParcialSubRotaSucesso: Resposta<IResponseFolhaParcialSubRotaSucesso>;
  ResponseFolhaParcialSucesso: RespostaFolhaV2<DiaDaFolhaResponse>
  ResponsePadraoFastAPI: RespostaFolhaV2<IResponsePadraoFastAPI>
  ResponseAcumuladoBH: RespostaFolhaV2<IResponseAcumuladoBH>
  ResponseResumoBancoDeHorasPorEmpregado: RespostaFolhaV2<IResponseResumoBancoDeHorasPorEmpregado>
}

export interface IFolhaRepositorio {
  http: HttpCondominio
  httpFastAPI: HttpFastAPI
  obterLoteDeLinhasPorLocalDeTrabalho(data: IRequestFolhaParcialLoteDeLinhasPorLocalDeTrabalho, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaLinhasSucesso']
  obterLoteDeLinhasPorEmpregado(data: IRequestFolhaParcialLoteDeLinhasEmpregado, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaLinhasSucesso']
  obterLoteDeLinhasPorGrupo(data: IRequestFolhaParcialLoteDeLinhasGrupo, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaLinhasSucesso']

  obterLoteDeMarcacoesDasLinhas(data: IRequestFolhaParcialSubRotaBase, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaSucesso']
  obterLoteDeJornadaDiariasDasLinhas(data: IRequestFolhaParcialSubRotaBase, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaSucesso']
  obterLoteDeAprovacoesDasLinhas(data: IRequestFolhaParcialSubRotaBase, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaSucesso']
  obterLoteDeBancoDeHorasDasLinhas(data: IRequestFolhaParcialSubRotaBase, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaSucesso']
  obterLoteDeJustificativasDasLinhas(data: IRequestLoteDeJustificativasDasLinhas, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaSucesso']
  obterDiasDaFolhaPorEntidade(data: IRequestDiasDaFolhaPorEntidade, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSucesso']
  recalcularDiasQuePrecisam(data: IRequestDiasDaFolhaPorEntidade, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSucesso']
  regerarJornadasQuePrecisam(data: IRequestRegerarJornadasQuePrecisam, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSucesso']
  gerarJornadasQueFaltam(data: IRequestGerarJornadasQueFaltam, config: AxiosRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSucesso']
  processarPontosDaFolha(data: IRequestProcessarPontos, config: AxiosRequestConfig): HelperFolhaResposta['ResponsePadraoFastAPI']
  verificarDiaDafolha(data: IRequestVerificarDia, config?: AxiosRequestConfig): HelperFolhaResposta['ResponsePadraoFastAPI']
  obterAcumuladoBancoDeHoras(data: IRequestAcumuladoBH): HelperFolhaResposta['ResponseAcumuladoBH']
  obterResumoBancoDeHorasPorEmpregado(data: IRequestResumoBancoDeHorasPorEmpregado): HelperFolhaResposta['ResponseResumoBancoDeHorasPorEmpregado']
}
